import _ from 'lodash';
import { FILES_ACTIONS } from '../../../../redux/files/files.actions';
import { Action } from '../../../../redux/redux.types';
import {
  SingleFileUploadPayload,
  UploadErrorActionPayload,
  UploadFileSuccessPayload,
} from '../../../../types/media-assets';
import { StringMap } from '../../../../types/system';
import { OPERATION_GROUPS_ACTION_NAMES } from '../operation-groups.actions';
import {
  FileUploadStatus,
  FileUploadStatusType,
  FileUploadSucceeded,
} from '../operation-groups.types';

export type UploadOperationsState = StringMap<FileUploadStatus>;

const defaultState: UploadOperationsState = {};

function isFileUploadSucceeded(
  operation: FileUploadStatus,
): operation is FileUploadSucceeded {
  return (
    (operation as FileUploadSucceeded).type === FileUploadStatusType.Uploaded
  );
}

export const uploadOperations = (
  state: UploadOperationsState = defaultState,
  { type, payload }: Action,
): UploadOperationsState => {
  switch (type) {
    case FILES_ACTIONS.FILE_CREATING: {
      const { id, file, path }: SingleFileUploadPayload = payload;
      return {
        ...state,
        [id]: {
          type: FileUploadStatusType.Uploading,
          clientId: id,
          file,
          path,
        },
      };
    }

    case FILES_ACTIONS.FILE_UPLOAD_ERROR: {
      const { clientId, file, path }: UploadErrorActionPayload = payload;
      return {
        ...state,
        [clientId]: {
          type: FileUploadStatusType.Failed,
          clientId,
          file,
          path,
        },
      };
    }

    case FILES_ACTIONS.FILE_UPLOAD_SUCCESS:
    case FILES_ACTIONS.FILE_CREATE: {
      const { clientId, file }: UploadFileSuccessPayload = payload;
      return {
        ...state,
        [clientId]: {
          type: FileUploadStatusType.Uploaded,
          clientId,
          fileId: file.id,
        },
      };
    }

    case FILES_ACTIONS.FILE_DELETE_SUCCESS:
      return _.omitBy(state, (operation) => {
        if (!isFileUploadSucceeded(operation)) {
          return false;
        }

        return operation.fileId === payload.id;
      }) as StringMap<FileUploadStatus>; // because _.omitBy returns Partial<T> but we need only <T>

    case OPERATION_GROUPS_ACTION_NAMES.CLOSE_GROUP:
      return _.omit(state, payload.operationIds);

    default:
      return state;
  }
};
